import * as React from "react"
import IParkingAvailabilityModel from "../../interfaces/IParkingAvailabilityModel"
import { AvailabilityIndicator } from "./AvailabilityIndicator"

export function ParkingAvailabilityTile(props: IParkingAvailabilityModel) {
  const {
    facilityName,
    estimatedParkingSpacesAvailable,
    parkingSpacesTotal,
  } = props
  return (
    <div className="parking-availability-tile my-2 mx-auto">
      <AvailabilityIndicator
      facilityName={facilityName}
        estimatedParkingSpacesAvailable={estimatedParkingSpacesAvailable}
        parkingSpacesTotal={parkingSpacesTotal}
      />
    </div>
  )
}
